import React,{useEffect,useState} from 'react'
import classes from './CategoryPage.module.css'
import { useParams } from 'react-router-dom'
import Videos from '../Components/Videos'
import axios from 'axios'
import { fetch_data } from '../Services/api'
import Header from '../Components/Header'
import Footer from '../Components/Footer'

const CategoryPage = () => {
    const {category} = useParams()

    const [videos,setVideos] = useState([]);
    const [categoryName,setcategoryName] = useState('');


    const fetchData=async()=>{
       
        const res = await axios.get(fetch_data);
        console.log(res.data)

        const categories = res.data.categories;
        setcategoryName(categories.find((item)=>item.id == category)?.name)
        const videos = res.data.videos.filter((item)=>item.categoryId == category)
        console.log(videos)
        setVideos(videos)
        
        
    }

    useEffect(() => {
        fetchData();
    }, [category])


  return (
    <div className={classes.container}>
      <Header/>
     <div className={classes.main}>
     <div className={classes.title}>
      {categoryName}
      </div>
      <Videos videos={videos}/>
     </div>
     <Footer/>
    </div>
  )
}

export default CategoryPage
